import { render, staticRenderFns } from "./FormPartida.vue?vue&type=template&id=19352121&scoped=true&"
import script from "./FormPartida.vue?vue&type=script&lang=js&"
export * from "./FormPartida.vue?vue&type=script&lang=js&"
import style0 from "./FormPartida.vue?vue&type=style&index=0&id=19352121&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19352121",
  null
  
)

export default component.exports